import { t } from 'ttag';
import { OPENING_HOURS_FIELDS } from 'constants.js';
import { WEEKDAYS_SHORT } from 'i18n/index.js';
import './index.scss';

const OpeningHoursSingle = ({ label, value }) => (
    <li className='opening-hours-row'>
        <span className='opening-hours-label'>{label} </span>
        <span className='opening-hours-value'>{value}</span>
    </li>
);

const OpeningHours = ({ shop, className = '', ...rest }) => {
    if(!shop || OPENING_HOURS_FIELDS.every(k => !shop[k])) return null;

    const i18n = WEEKDAYS_SHORT();
    const monday = shop[OPENING_HOURS_FIELDS[0]];
    const areMonToFriSame = OPENING_HOURS_FIELDS.slice(0, 5).every(k => shop[k] === monday);

    return (
        <ol className={`opening-hours-list ${className}`} {...rest}>
            {areMonToFriSame && <OpeningHoursSingle label={t`MON-FRI`} value={monday} />}
            {(areMonToFriSame ? OPENING_HOURS_FIELDS.slice(5) : OPENING_HOURS_FIELDS).map((k, i) => (
                <OpeningHoursSingle key={k} label={i18n[i + 5 * areMonToFriSame]} value={shop[k]} />
            ))}
        </ol>
    );
};

export default OpeningHours;
